import React from 'react';
import { Switch, Route, useHistory, useParams, Link } from 'react-router-dom';

import BrowserOnly from 'components/consumer/BrowserOnly';
import useProductAttributes from 'data-hooks/useProductAttributes';
import PDPProductDetailsModal from 'components/consumer/PDP/PDPProductDetailsModal';

const PDPDetailsAndProductCareLink = () => {
  const history = useHistory();

  const {
    data: { assemblyDetailsPDF },
  } = useProductAttributes();

  const { category, slug } = useParams();
  const pathToDetailsModal = `/${category}/${slug}/details`;

  return (
    <div className="PDPDetailsAndProductCareLink">
      <Link
        to={pathToDetailsModal}
        className="text-base font-bold text-brand cursor-pointer hover:underline"
      >
        {assemblyDetailsPDF
          ? `Details, product care & assembly instructions +`
          : `Details and product care +`}
      </Link>

      <Switch>
        <Route path="/:category/:slug/details">
          <BrowserOnly>
            <PDPProductDetailsModal
              isOpen
              onClose={() => {
                history.goBack();
              }}
            />
          </BrowserOnly>
        </Route>
      </Switch>
    </div>
  );
};

export default PDPDetailsAndProductCareLink;
